import { createContext } from "react";

export const Battle = createContext(null)